import { PokerChipIcon } from './PokerChipIcon';

/**
 * author: Michael Richins
 * id D73F724D-EEE6-43EC-BA3A-E185ABD7A258
 * name poker-chip
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/poker-chip.svg
 * tags
 * - Gaming / RPG 
 */
export const GamblingChipIcon = PokerChipIcon;
export default GamblingChipIcon